module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-open-numeric-fc9c4b27b5069a8e961b80196c2371d2.png";